import { PRIMARY } from '../../styles';

export default {
  title: {
    backgroundColor: PRIMARY,
    color: 'white',

  },
  subTitle: {
    fontSize: 14,
    whiteSpace: 'pre-wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  body: {
    padding: 0,
  },
  titleContainer: {
    display: 'flex',
  },
  titleSubTitleContainer: {
    flex: 1,
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/ReduxDialog/styles.js